export default class Scheduler {

    id = null;
    name = '';
    active = false;
    buffer = null;
    slots = null;
    budgetPriority = null;
    diversityPriorty = null;
    mutationsInnerLoop = null;
    mutationsOuterLoop = null;
    innerGenerations = null;
    outerGenerations = null;

    constructor() {
    }
}